import React from "react";
import {
    CardContent,
    CardText,
    CardTitle,
    ContactButton,
    ContactCard,
    Container,
    HomeHeader,
    InfoCard,
    InfoCardText,
    SubTitleHeader,
    TitleHeader
} from "./Home.css";
import {Button, Card} from "@elcimai/webankdesignsystem";
import cardLogo from "/assets/api-card-logo.svg?url"
import consultationLogo from "/assets/api-consultation-logo.svg?url"
import oauth2Logo from "/assets/api-oauth2-logo.svg?url"
import StoreItem from "../../components/storeItem/StoreItem";
import {useNavigate} from "react-router-dom";
import {Recommended} from "../../global.css";

function Home() {
    const navigate = useNavigate()
    return (
        <div>
            <div className={HomeHeader}>
                <p className={TitleHeader}>Banque Pouyanne : Store API DSP2</p>
                <p className={SubTitleHeader}>Accédez à l'innovation dans les services de paiement avec nos API sécurisés</p>
            </div>

            <div className={Container}>
                <h2>Nos APIs</h2>
                <p>Propulsez vos transactions et gérez vos finances avec nos APIs</p>
                <div className={Recommended}>
                    <StoreItem
                        title={"AISP"}
                        description={"Prestataires de services d’information sur les comptes"}
                        onClick={() =>navigate("/aisp")}
                        imageUrl={consultationLogo}>
                    </StoreItem>
                    <StoreItem
                        title={"PISP"}
                        description={"Prestataires de services d’initiation de paiement"}
                        onClick={() =>navigate("/pisp")}
                        imageUrl={cardLogo}>
                    </StoreItem>
                    <StoreItem
                        title={"OAuth2"}
                        description={"Protocole d'autorisation à accès limité aux ressources utilisateur"}
                        onClick={() =>navigate("/oauth2")}
                        imageUrl={oauth2Logo}>
                    </StoreItem>
                </div>
                <Card className={InfoCard}>
                    <div className={CardContent}>
                        <p className={`${InfoCardText} ${CardTitle}`}>Qu’est-ce que la DSP2 ?</p>
                        <p className={InfoCardText}>La directive sur les services de paiement, dite DSP2, vise à harmoniser la réglementation sur les paiements au sein de l’Union Européenne. Son objectif est de moderniser les services de paiement en Europe au profit tant des consommateurs que des entreprises, de faciliter l’usage des moyens de paiement et de renforcer la sécurité des opérations de paiements des entreprises.</p>
                    </div>
                </Card>
                <Card className={ContactCard} isBehind={true}>
                    <div className={CardContent}>
                        <p className={CardTitle}>Besoin s'aide ?</p>
                        <p className={CardText}>N’hésitez pas à contacter notre service technique.</p>
                        <Button className={ContactButton} label={"Nous contacter"} onClick={() =>navigate("/home/contact")}></Button>
                    </div>
                </Card>
            </div>
        </div>
    )
}

export default Home;